import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="step-nav"
//
// The compact step bar shown on phones: tapping it reveals the full list of
// steps. Desktop renders the stepper inline and never uses this.
export default class extends Controller {
  static targets = ["sheet", "chevron", "trigger"]

  toggle() {
    if (!this.hasSheetTarget) return

    const open = this.sheetTarget.classList.toggle("hidden")
    const expanded = !open

    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-180", expanded)
    }

    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", expanded.toString())
    }
  }
}
